import moment from 'moment'
import { initializeApp } from "firebase/app"
import { 
  getDatabase, ref, set, 
  update, remove, onValue 
} from "firebase/database"

class FirebaseService {
  constructor () {
    console.log('CONSTRUCT FirebaseService')
    this.fbDatabase = null
    this.path = `users/$cpf/telessaude/sala/$cpf`
    this.pathLog = `telessaude-log/$cpf/`
    this.setFirebaseConfig()
  }

  /**
   * Configura a conexão com o Firebase.
   */
  setFirebaseConfig () {
    const config = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
      authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.VUE_APP_FIREBASE_APP_ID
    }
    const firebaseApp = initializeApp(config)
    this.fbDatabase = getDatabase(firebaseApp)
  }

  /**
   * Define o valor da sala no Firebase Realtime Database.
   * @param {string} cpf - O CPF do usuário.
   * @param {object} agoraSdk - Informações adicionais para o payload.
   */
  setFirebaseRoom (cpf, agoraSdk) {
    const cpfFormat = cpf.replace(/[.-]/g, '')
    const payload = {
      cpf: cpfFormat,
      agoraSdk,
      funNome: null,
      funStreamId: null,
      pacStreamId: null,
      created_at: moment().format('DD/MM/YYYY - HH:mm:ss')
    }
    const path = this.path.replace(/\$cpf/g, cpfFormat)
    console.warn('[setFirebaseRoom] path', path)
    set(ref(this.fbDatabase, path), payload)
    .then(() => {
      console.info('[setFirebaseRoom] sala criada/atualizada com sucesso')
      this._setMovimentLog('insert', `Criar sala: ${agoraSdk.canal}`,cpf, payload)
      return true
    })
    .catch((error) => {
      console.error('[setFirebaseRoom] Erro:', error)
      return false
    })
  }

  /**
   * Atualiza uma chave específica na sala do Firebase com base no CPF fornecido.
   * @param {string} cpf - O CPF do usuário, contendo pontos e traços (que serão removidos).
   * @param {string} key - A chave específica a ser atualizada no Firebase.
   * @param {*} value - O valor a ser aplicado à chave.
   * @returns {Promise<boolean>} Retorna `true` se a atualização for bem-sucedida, caso contrário, `false`.
  */
  updateFirebaseRoom (cpf, key, value) {
    const cpfFormat = cpf.replace(/[.-]/g, '')
    const path = `${this.path.replace(/\$cpf/g, cpfFormat)}/agoraSdk`
    const payload = {
      [key]: value,
      updated_at: moment().format('DD/MM/YYYY - HH:mm:ss') // Atualiza também a data de modificação
    }  
    update(ref(this.fbDatabase, path), payload)
    .then(() => {
      console.info(`[updateFirebaseRoom] Chave ${key} atualizada com sucesso`)
      this._setMovimentLog('update', `${key}: ${value}`, cpf, payload)
      return true
    })
    .catch((error) => {
      console.error(`[updateFirebaseRoom] Erro ao atualizar a chave ${key}:`, error)
      return false
    })
  }

  /**
   * Remove a sala de telessaúde de um paciente com base no CPF.
   * @param {string} cpf - O CPF do paciente (chave do Firebase).
   * @returns {Promise<void>} - Retorna uma promessa que resolve quando a sala for removida.
   */
  removeTelehealthRoom (cpf) {
    const cpfFormat = cpf.replace(/[.-]/g, '')
    const path = `users/${cpfFormat}/telessaude/sala`
    const roomRef = ref(this.fbDatabase, path)
    remove(roomRef)
      .then(() => {
        this._setMovimentLog('delete', `via Paciente`, cpfFormat, { path })
      })
      .catch((error) => {
        console.error('Erro ao remover a sala de telessaúde:', error)
      })
  }

  /**
   * Escuta as mudanças na sala associada ao CPF no Firebase.
   * @param {string} cpf - O CPF do usuário.
   * @param {function} callback - Função de callback que será chamada quando ocorrerem mudanças nos dados da sala.
   */
  listenerRoomByCpf(cpf, callback) {
    const cpfFormat = cpf.replace(/[.-]/g, '');
    const path = this.path.replace(/\$cpf/g, cpfFormat);
    const roomRef = ref(this.fbDatabase, path);

    onValue(roomRef, (snapshot) => {
      const currentData = snapshot.val();
      callback(currentData)
    }, {
      onlyOnce: false
    });
  }

  /**
   * Armazena o log de movimentação da sala com o ID sendo o timestamp.
   * @param {object} payload - O payload contendo as informações da sala.
   * @private
   */
  _setMovimentLog (type, subtype, cpf, payload) {
    const timestamp = moment().format('YYYYMMDDHHmmssSSS')
    payload.created_at = moment().format('DD/MM/YYYY - HH:mm:ss:SSS')
    payload.type = `CABINE ${type}`
    payload.subtype = subtype
    const cpfFormat = cpf.replace(/[.-]/g, '')
    const path = `${this.pathLog.replace(/\$cpf/g, cpfFormat)}/${timestamp}`
    set(ref(this.fbDatabase, path), payload)
    .then(() => {
      console.info('[_setMovimentLog] Log de movimentação registrado com sucesso')
      return true
    })
    .catch((error) => {
      console.error('[_setMovimentLog] Erro ao registrar o log de movimentação:', error)
      return false
    })
  }
}

export default FirebaseService